import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const MinusIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="MinusIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/minus">
            <path fill="none" id="Vector" d="M6 12H18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"></path>
        </g>
    </SvgIcon>
)
